import _defineProperty from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { useSpacing } from '../../api/spacing/useSpacing';
import { pickDataProps, pickAriaProps, pickComponentCommonProps } from '../../interfaces/commonProps';
import { useLocale } from '../LocaleProvider';
import { PaginationVariant, StartEllipsis, EndEllipsis } from './Pagination.types';
import { StyledPaginationItem, StyledContainer, StyledPagination, StyledIconContainer, StyledArrow, StyledCurrentPage, StyledCompactWrapper } from './Pagination.styles';
import { getExtendedPages } from './getExtendedPages';
import { getNormalPages } from './getNormalPages';

var Arrow = function Arrow() {
  return React.createElement(StyledArrow, {
    xmlns: "http://www.w3.org/2000/svg",
    width: "8",
    height: "13",
    viewBox: "0 0 8 13"
  }, React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1px",
    fill: "none",
    d: "M1.5,1 l6,6 l-6,6"
  }));
};

export var Pagination = React.forwardRef(function (_ref, ref) {
  var _ref$children = _ref.children,
      renderItem = _ref$children === void 0 ? function (props) {
    return React.createElement("button", _objectSpread({}, props));
  } : _ref$children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? PaginationVariant.normal : _ref$variant,
      count = _ref.count,
      page = _ref.page,
      _ref$nav = _ref.nav,
      nav = _ref$nav === void 0 ? false : _ref$nav,
      navLabel = _ref.navLabel,
      _ref$onChange = _ref.onChange,
      handleChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      restProps = _objectWithoutProperties(_ref, ["children", "variant", "count", "page", "nav", "navLabel", "onChange"]);

  var _useLocale = useLocale(),
      locale = _useLocale.pagination;

  var isFirstPage = page === 1;
  var isLastPage = page === count;
  var prevPageIndex = page - 1;
  var nextPageIndex = page + 1;
  return React.createElement(StyledContainer, _objectSpread({
    ref: ref,
    as: nav ? 'nav' : 'div'
  }, nav ? {
    'aria-label': navLabel || locale.ariaLabel
  } : {}, {
    outerSpacing: useSpacing(restProps)
  }, pickComponentCommonProps(restProps), {}, pickDataProps(restProps), {}, pickAriaProps(restProps)), React.createElement(StyledPagination, {
    count: count,
    variant: variant
  }, React.createElement(StyledPaginationItem, null, renderItem({
    page: prevPageIndex,
    disabled: isFirstPage,
    'aria-disabled': isFirstPage,
    'aria-label': locale.ariaGoToPrevious,
    onClick: function onClick(event) {
      return handleChange(prevPageIndex, event);
    },
    children: React.createElement(React.Fragment, null, React.createElement(StyledIconContainer, {
      prev: true
    }, React.createElement(Arrow, null)), variant === PaginationVariant.minimalWithLabels && locale.previous)
  })), variant === PaginationVariant.compact && React.createElement(StyledPaginationItem, null, React.createElement(StyledCompactWrapper, null, React.createElement(StyledCurrentPage, {
    "aria-current": "page"
  }, page), "/", count)), variant === PaginationVariant.normal && getNormalPages({
    currentPage: page,
    totalPages: count
  }).map(function (item) {
    var isCurrentPage = item === page;
    return React.createElement(StyledPaginationItem, {
      key: "item__".concat(item, "__").concat(count)
    }, renderItem({
      page: item,
      'aria-disabled': false,
      'aria-current': isCurrentPage ? 'page' : false,
      'aria-label': isCurrentPage ? locale.ariaCurrentPage(item) : locale.ariaGoToPage(item),
      onClick: function onClick(event) {
        return handleChange(item, event);
      },
      children: item
    }));
  }), variant === PaginationVariant.extended && getExtendedPages({
    currentPage: page,
    totalPages: count
  }).map(function (item) {
    var isCurrentPage = item === page;
    return React.createElement(StyledPaginationItem, {
      key: "item__".concat(item, "__").concat(count)
    }, item === StartEllipsis || item === EndEllipsis ? React.createElement("span", null, locale.ellipsis) : renderItem({
      page: item,
      'aria-disabled': false,
      'aria-current': isCurrentPage ? 'page' : false,
      'aria-label': isCurrentPage ? locale.ariaCurrentPage(item) : locale.ariaGoToPage(item),
      onClick: function onClick(event) {
        return handleChange(item, event);
      },
      children: item
    }));
  }), React.createElement(StyledPaginationItem, null, renderItem({
    page: nextPageIndex,
    disabled: isLastPage,
    'aria-disabled': isLastPage,
    'aria-label': locale.ariaGoToNext,
    onClick: function onClick(event) {
      return handleChange(nextPageIndex, event);
    },
    children: React.createElement(React.Fragment, null, variant === PaginationVariant.minimalWithLabels && locale.next, React.createElement(StyledIconContainer, {
      next: true
    }, React.createElement(Arrow, null)))
  }))));
});
Pagination.displayName = 'Pagination';